<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col cols="12">
          <b-card>
            <totalizador-documentos />
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card>
            <detalhamento-status-equipe />
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-card>
            <entrega-documento-equipe />
          </b-card>
        </b-col>
        <b-col cols="6">
          <b-card>
            <indice-empresas />
          </b-card>
          <b-card>
            <configuracao-cobranca />
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card>
            <configuracao-cobranca-tabela />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'DashboardCobranca',
  components: {
    TotalizadorDocumentos: () => import('./shared/components/totalizador-documentos/TotalizadorDocumentos.vue'),
    EntregaDocumentoEquipe: () => import('./shared/components/entrega-documentos-equipe/EntregaDocumentosEquipe.vue'),
    DetalhamentoStatusEquipe: () => import('./shared/components/detalhamento-status-equipe/DetalhamentoStatusEquipe.vue'),
    IndiceEmpresas: () => import('./shared/components/indice-empresas/IndiceEmpresas.vue'),
    ConfiguracaoCobranca: () => import('./shared/components/configuracao-cobranca/ConfiguracaoCobranca.vue'),
    ConfiguracaoCobrancaTabela: () => import('./shared/components/configuracao-cobranca/configuracao-cobranca-tabela/ConfiguracaoCobrancaTabela.vue'),
  },
  created() {
    // this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true)
    // this.aplicar()
  },
  destroyed() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', false)
  },
  methods: {
  },
}
</script>
